<template>
  <div class="illustration-colors-content" id="identidade-visual-ilustracao-cores" data-search-anchor>
    <div class="illustration-title-colors-wrapper">
      <h1 class="illustration-colors-title-span">{{ illustrationColorsTitleSpan }}</h1>
      <h1 class="illustration-colors-title">{{ illustrationColorsTitle }}</h1>
    </div>
    <div class="description-illustration-colors-wrapper">
      <div class="illustration-colors-wrapper">
        <p class="illustration-colors-description" style="margin: 0;">{{ illustrationColorsDescription }}</p>
      </div>
      <div class="illustration-colors-wrapper"></div>          
                
      <div class="illustration-colors-icon-wrapper">
        <IconCheck />
        <p class="illustration-colors-description-icon">{{ illustrationColorsDescription1 }}</p>        
      </div>
      <div class="illustration-colors-icon-wrapper">        
        <IconCheck />
        <p class="illustration-colors-description-icon">{{ illustrationColorsDescription2 }}</p>
      </div>
      </div>
    <div
      class="illustration-colors-card-item"
      :style="{ backgroundImage: `url(${illustrationColorsImageSrc})` }"
    ></div>
    </div>  
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class IllustrationColorsSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get illustrationColorsTitleSpan(): string {
    return this.getElementTitle(3, 0)
  }

  get illustrationColorsTitle(): string {
    return this.getElementText(3, 0)
  }

  get illustrationColorsDescription(): string {
    return this.getElementText(3, 1)
  }

  get illustrationColorsDescription1(): string {
    return this.getElementText(3, 2)
  }

  get illustrationColorsDescription2(): string {
    return this.getElementText(3, 3)
  }

  get illustrationColorsImageSrc(): string {
    return this.getElementMedia(3, 4)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style scoped>
.illustration-colors-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-title-colors-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.illustration-colors-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-colors-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-illustration-colors-wrapper {
  position: relative;  
  display: grid;
  grid-template-columns: 50% 50%;  
}

.illustration-colors-description,
.illustration-colors-description-icon {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
}

.illustration-colors-description,
.illustration-colors-description-icon {  
  white-space: pre-line;
}

.illustration-colors-description-icon {
  padding-left: 7px;
  width: 378px;  
}

.illustration-colors-wrapper,
.illustration-colors-icon-wrapper {
  display: flex;  
  align-items: center;
}

.illustration-colors-card-item {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 550px;
  border-radius: 12px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
